document.cookie = 'post-protection=1; expires=' + (new Date(new Date().getTime() + (86400 * 7 * 1000))).toGMTString() + '; path=/; secure; samesite=none';


// Navigation
$(document).ready(function() {
	let $html           = $('html');
	let $menuContent    = $('#menuContent');
	let $nav            = $('nav');
	let $searchWrapper  = $('#searchWrapper');
	let $searchControl  = $('a#searchControl');
	let $menuControl    = $('a#menuControl');
	let $closeControl   = $('a#closeControl');
	let $navSubControl  = $('.content nav a.submenuControl');

	$menuControl.click(function () {
		$menuControl.parent().removeClass('active');
		$searchWrapper.removeClass('active');

		$html.addClass('mobileMenuActive');
		$menuContent.addClass('show').removeClass('hide');
		$searchControl.parent().addClass('active');
		$closeControl.parent().addClass('active');
		$nav.addClass('active');
	});

	$searchControl.click(function () {
		$searchControl.parent().removeClass('active');
		$nav.removeClass('active');

		$html.addClass('mobileMenuActive');
		$menuContent.addClass('show').removeClass('hide');
		$menuControl.parent().addClass('active');
		$closeControl.parent().addClass('active');
		$searchWrapper.addClass('active');
	});

	$closeControl.click(function () {
		$closeControl.parent().removeClass('active');
		$searchWrapper.removeClass('active');
		$nav.removeClass('active');

		$menuControl.parent().addClass('active');
		$searchControl.parent().addClass('active');

		$menuContent.addClass('hide').removeClass('show');

		setTimeout(function () {
			$closeControl.parent().removeClass('active');
			$searchWrapper.removeClass('active');
			$nav.removeClass('active');

			$menuControl.parent().addClass('active');
			$searchControl.parent().addClass('active');

			$menuContent.removeClass('show').removeClass('hide');
			$html.removeClass('mobileMenuActive');
		}, 400);
	});

	$navSubControl.click(function (event) {
		let $this    = $(this);
		let $submenu = $this.parent().find('ul');
		let isActive = $submenu.hasClass('active');

		$('li > ul.active').removeClass('active');
		$('li > a.submenuControl').removeClass('active');

		if (!isActive) {
			$submenu.addClass('active');
			$this.addClass('active');
		}

		event.preventDefault();
		return false;
	});

	// Mobile Language Switcher
	let $langSwitcher = $('#languageSwitcherMobile');
	let $langControl  = $langSwitcher.find('> .submenuControl');

	$langControl.click(function(e) {
		e.preventDefault();
		$langSwitcher.toggleClass('open');
		return false;
	});
});
